import React, { useEffect, useState } from 'react';

import axios from 'axios';
import  {BarChart,ResponsiveContainer,Bar,XAxis, YAxis} from 'recharts';
import LineChart from 'echarts-for-react';


  

function Bars(){
  let color=["#3b82f6","#15b8a7","#f49d0d"]
  const [labels,setLabels]=useState([])
  let [series,setSeries]=useState([])

  const [graphdata,setData]=useState([
      {
        day:"Monday",
       
        
      },
      {
        day:"Tuesday",
        
      },
      {
        day:"Wednesday",
        
      },
      {
        day:"Thursday",
        
      },
      {
        day:"Friday",
        
      },
      {
        day:"Saturday",
        
      },
      {
        day:"Sunday",
        
      },
      
    ])
  useEffect(()=>{
    let tempLabels=[...labels]
        axios.get(process.env.REACT_APP_API_POINT +'DQ-pipeline/pipeline-details-Q2-WTD',{headers:{Authorization: 'Bearer '+sessionStorage.getItem('token')}}).then((data)=>{
          if(data.data.success){
    
            data.data['DQ-Pipeline-Details-Q2 WTD Data'].forEach(element => {
              
              
              if(!tempLabels.includes(element['Pipeline Flag'])){
                tempLabels.push(element['Pipeline Flag'])
              }
              
let tempGraphData=[...graphdata]
              tempGraphData.forEach((ele)=>{
                if(element['Day']==ele.day){
                  ele[element['Pipeline Flag']]=element['WTD Issues Occured']
                }
              })
              setData(tempGraphData)
              let tempSeries=[]
          tempLabels.forEach((ele,index)=>{
            console.log(ele)
            let arr={
              data: [],
              type: 'bar',
              color:color[index]
            }
            tempGraphData.forEach((d)=>{
              if(d[ele]){
                arr.data.push(d[ele])
              }else{
                arr.data.push(0)
              }
            })
           
              tempSeries.push(arr)
            
          })
          
          setSeries(tempSeries)
            })
          }
        })         
        setLabels(tempLabels)     
      },[])
  
return (<>
    <LineChart height={"20%"}
        option={{
          tooltip:{
            show:true
          },
          xAxis: {
            type: 'category',
            data: ['Mon',"Tue","Wed","Thu","Fri","Sat","Sun"]
          },
          yAxis: {
            type: 'value'
          },
          series:series
        }}
      />
  <span className="d-flex justify-content-center text-dark" >{labels.map((label,index)=>{ return <><span className="m-2" style={{backgroundColor:color[index], height:"12px",width:"12px",borderRadius:"5px"}}  /><span className="m-1">{label}</span></>})}</span>
</>)
  // return (<div style={{position:"relative"}} className='d-flex flex-column justify-content-end'>
  //   <ResponsiveContainer width={"98%"} height={"90%"} aspect={1.8}>
  //     <BarChart data={graphdata} >
  //     <XAxis dataKey="day" fontSize={10}></XAxis>
  //     <YAxis ></YAxis>
  //      {labels.map((lab,ind)=>{return <Bar barSize={12} fill={color[ind]} dataKey={lab} />})}
        

  //     </BarChart>
  //   </ResponsiveContainer>
  // <span className="d-flex justify-content-center text-dark" >{labels.map((label,index)=>{ return <><span className="m-2" style={{backgroundColor:color[index], height:"12px",width:"12px",borderRadius:"5px"}}  /><span className="m-1" style={{fontSize:"16px"}}>{label}</span></>})}</span>

  // </div>)
}
export default Bars;
